<script>
    export let value = null
    export let name = null
    export let required = false
    import { getContext, onDestroy } from 'svelte'
    let formData = getContext('formData')
    $: if (((value && name) || name) && formData)
        formData.update((x) => {
            return Object.assign(
                x,
                Object.fromEntries([
                    [
                        name,
                        {
                            valid: true,
                            validation: false,
                            required,
                            value,
                            label: null,
                            labelOption: null,
                        },
                    ],
                ])
            )
        })
    onDestroy((_) => {
        if (((value && name) || name) && formData) {
            formData.update((all) => {
                return Object.fromEntries(
                    Object.entries(all).filter(([n]) => name != n)
                )
            })
        }
    })
</script>
